import React from 'react';
import styled from 'styled-components';

const AboutSection = styled.section`
  padding: 5rem 0;
  background-color: var(--background-white);
`;

const SectionContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3rem;
  
  @media (max-width: 992px) {
    flex-direction: column;
  }
`;

const AboutContent = styled.div`
  flex: 1;
`;

const SectionTitle = styled.h2`
  font-family: 'Libre Baskerville', serif;
  font-size: 2.5rem;
  color: var(--primary-color);
  margin-bottom: 1rem;
`;

const SectionSubtitle = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-size: 1.2rem;
  color: var(--accent-color);
  margin-bottom: 1.5rem;
`;

const AboutText = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 1rem;
  color: var(--text-dark);
  margin-bottom: 1.5rem;
  line-height: 1.8;
`;

const AboutImageWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  
  @media (max-width: 992px) {
    order: -1;
  }
`;

const AboutImage = styled.div`
  width: 100%;
  max-width: 450px;
  height: 450px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 576px) {
    height: 300px;
  }
`;

const AboutDetails = styled.ul`
  list-style: none;
  margin: 2rem 0;
`;

const DetailItem = styled.li`
  font-family: 'Lato', sans-serif;
  margin-bottom: 1rem;
  display: flex;
  align-items: flex-start;
  
  &::before {
    content: '✓';
    color: var(--accent-color);
    margin-right: 0.5rem;
    font-weight: bold;
  }
`;

const AboutCTA = styled.a`
  display: inline-block;
  padding: 0.8rem 1.8rem;
  background-color: var(--accent-color);
  color: var(--text-light);
  border: none;
  border-radius: 5px;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: var(--primary-color);
  }
`;

const About = () => {
  return (
    <AboutSection id="about">
      <SectionContainer>
        <AboutContent>
          <SectionTitle>About Our Practice</SectionTitle>
          <SectionSubtitle>Serving North York Since 2011</SectionSubtitle>
          <AboutText>
            At Finch & Dudley Dental (formerly Yonge Finch Dental Implant Centre), we are committed to providing exceptional dental care in a
            comfortable and relaxed environment. Our experienced team of dental professionals uses the
            latest technologies and techniques to ensure you receive the highest quality care.
          </AboutText>
          <AboutText>
            Located at 78 Finch Avenue East in North York, our modern clinic serves all of your dental needs. We believe that a healthy smile is essential for overall
            wellbeing, and we strive to make dental care accessible and stress-free for everyone.
          </AboutText>
          <AboutDetails>
            <DetailItem>State-of-the-art dental equipment and technology</DetailItem>
            <DetailItem>Friendly and experienced dental professionals</DetailItem>
            <DetailItem>Committed to your safety: every room has HEPA filters, our staff wears masks, and will wear N95 masks on request</DetailItem>
            <DetailItem>Comfortable and welcoming environment</DetailItem>
            <DetailItem>Convenient location near TTC Line 1 (Finch) with ample parking</DetailItem>
          </AboutDetails>
          <AboutCTA href="#contact">Schedule Your Visit</AboutCTA>
        </AboutContent>
        <AboutImageWrapper>
          <AboutImage>
            <img src="/images/clinic-desk.jpg" alt="Finch & Dudley Dental reception area" />
          </AboutImage>
        </AboutImageWrapper>
      </SectionContainer>
    </AboutSection>
  );
};

export default About; 